/**
 * IconBadge - a custom icon inside a silver-and-green "app-icon" squircle
 * (the approved look). Green icon on a silver tile with a soft glossy
 * highlight. Pairs with <NavTile> and the home attention pane.
 */
import { Icon, type IconName } from './Icon';

interface IconBadgeProps {
  name: IconName | (string & {});
  /** Outer square size in px. Default 44. */
  size?: number;
  /** Icon size in px. Defaults to ~52% of the badge. */
  iconSize?: number;
  radius?: number;
  style?: React.CSSProperties;
}

export function IconBadge({ name, size = 44, iconSize, radius = 14, style }: IconBadgeProps) {
  return (
    <span
      style={{
        width: size,
        height: size,
        borderRadius: radius,
        background: 'linear-gradient(160deg, var(--paper) 0%, var(--silver-mist) 48%, var(--silver-soft) 100%)',
        color: 'var(--lime-deep)',
        border: '1px solid var(--silver-edge)',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.85), inset 0 -1px 2px rgba(10,10,10,0.06), 0 3px 8px rgba(10,10,10,0.10), 0 0 0 3px rgba(125,232,92,0.12)',
        ...style,
      }}
    >
      <Icon name={name} size={iconSize ?? Math.round(size * 0.52)} />
    </span>
  );
}

export default IconBadge;
